import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import FadeInSection from "../../ui/fade-in-section";
import SectionHeader from "../../ui/section-header";

export default function SessionsForgeCta() {
  return (
    <section className="saas-section bg-white overflow-hidden relative border-t border-slate-100">
      <div className="page-container relative z-10">
        <FadeInSection>
          <div className="saas-cta-panel w-full p-8 sm:p-12 lg:p-14 text-center relative overflow-hidden">
            <div
              className="absolute inset-0 opacity-[0.08]"
              style={{
                backgroundImage:
                  "radial-gradient(circle, #ffffff 1px, transparent 1px)",
                backgroundSize: "24px 24px",
              }}
              aria-hidden
            />
            <div
              className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-[#14B48C]/20 blur-3xl"
              aria-hidden
            />

            <div className="relative z-10">
              <SectionHeader
                light
                eyebrow="PYCRAY FORGE"
                title="Want structured mentorship beyond these sessions?"
                subtitle="PyCray Forge is our full 4-month training + internship program for engineering students and freshers — mentored directly by IIT/IIM alumni founders, with a paid internship pathway at PyCray Technologies for top performers."
                className="!mb-8"
              />

              <Link
                to="/forge"
                onClick={() => window.scrollTo(0, 0)}
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-xl bg-[#14B48C] hover:bg-[#11997A] text-white font-semibold shadow-lg shadow-[#14B48C]/25 transition-colors"
              >
                Learn About Forge
                <ArrowRight className="w-5 h-5" aria-hidden />
              </Link>
            </div>
          </div>
        </FadeInSection>
      </div>
    </section>
  );
}
